const blogTitle = ["Identifier", "category", "naming"];
const sizeBlogItemsOnPage = 5;

export { blogTitle, sizeBlogItemsOnPage };
